import { http } from '../../utils/http'

export const CRMBASE = window.$envUtils('VUE_APP_CRM_SERVICE')
export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

// 联系计划[新增]
export const creatConnPlan = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/connPlan`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询客户数量
export const getCustomerCount = (customerPropertyId) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/connPlan/findCustomerCount/${customerPropertyId}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 联系计划分页查询
export const getConnPlan = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/connPlan/findByPage`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 联系计划[删除]
export const deleteConnPlan = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`${CRMBASE}/connPlan`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 联系计划详情
export const getConnPlanDetail = (id) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/connPlan/findDetail/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 联系计划客户详情
export const getConnPlanCustomerDetail = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/connPlan/findCustomerDetails`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 根据筛选条件获取下拉框所有的技能组用户数据
export const getSkillGroup = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/skillgroup/getSkillGroup`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
